import {userConstants} from '../../_constants';

export function infoForUuid(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_INFO_FOR_UUID_REQUEST:
      return {
        loading: true,
        //items: [...action.items],
      };
    case userConstants.GET_INFO_FOR_UUID_SUCCESS:
      return {
        loading: false,
        ...action.data,
      };
    case userConstants.GET_INFO_FOR_UUID_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
